<template>
  <div class="profile-page">
    <div class="profile-header">
      <h1 class="page-title">个人中心</h1>
    </div>

    <div class="profile-content">
      <!-- 用户信息卡片 -->
      <div class="profile-card user-info-card">
        <div class="card-header">
          <h2>基本资料</h2>
        </div>
        <div class="card-content">
          <div class="user-info-container">
            <div class="avatar-section">
              <img 
                :src="userInfo.avatar ? IMAGE_BASE_URL + userInfo.avatar : defaultAvatar" 
                :alt="userInfo.nickname || '用户'" 
                class="user-avatar"
              >
              <div class="avatar-overlay">
                <span class="edit-text">修改头像</span>
              </div>
            </div>
            <div class="user-details">
              <div class="info-row">
                <span class="info-label">用户名</span>
                <span class="info-value">{{ userInfo.nickname || '未设置' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">手机号</span>
                <span class="info-value">{{ formatPhone(userInfo.phone) }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">注册时间</span>
                <span class="info-value">{{ formatDate(userInfo.createdAt) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getUserDetail } from '../api';
import { IMAGE_BASE_URL } from '../utils/constants';


export default {
  name: 'UserProfile',
  components: {},
  data() {
    return {
      userInfo: {},
      loading: false,
      IMAGE_BASE_URL,
      defaultAvatar: 'https://picsum.photos/id/1/300/300'
    }
  },
  created() {
    this.fetchUserData();
  },
  methods: {
    async fetchUserData() {
      this.loading = true;
      try {
        // 先尝试从localStorage获取用户信息
        const cachedUserInfo = localStorage.getItem('userInfo');
        if (cachedUserInfo) {
          this.userInfo = JSON.parse(cachedUserInfo);
        }
        
        // 从API获取最新数据
        const res = await getUserDetail();
        if (res.rc === 1 && res.data) {
          this.userInfo = res.data;
          // 缓存用户信息
          localStorage.setItem('userInfo', JSON.stringify(res.data));
        }
      } catch (error) {
        console.error('获取用户信息出错:', error);
      } finally {
        this.loading = false;
      }
    },
    formatPhone(phone) {
      if (!phone) return '未绑定';
      // 格式化手机号 139****1234
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    formatDate(timestamp) {
      if (!timestamp) return '未知';
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    viewAllFavorites() {
      // 查看全部收藏
      console.log('查看全部收藏');
    },
    viewAllHistory() {
      // 查看全部历史
      console.log('查看全部历史');
    },
    
  }
}
</script>

<style scoped>
.profile-page {
  padding-bottom: 40px;
}

.profile-header {
  margin-bottom: 20px;
}

.page-title {
  font-size: 24px;
  font-weight: 500;
  color: #333;
}

.profile-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.profile-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.card-header h2 {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 0;
}

.view-all {
  font-size: 16px;
  color: #4169e1;
  cursor: pointer;
}

.view-all:hover {
  text-decoration: underline;
}

.card-content {
  padding: 20px;
}

.user-info-container {
  display: flex;
  align-items: center;
  gap: 30px;
}

.avatar-section {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
}

.user-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.avatar-section:hover .avatar-overlay {
  opacity: 1;
}

.edit-text {
  color: #fff;
  font-size: 12px;
}

.user-details {
  flex: 1;
}

.info-row {
  display: flex;
  margin-bottom: 15px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  width: 80px;
  color: #999;
  font-size: 14px;
}

.info-value {
  color: #333;
  font-size: 14px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
}

.empty-icon {
  margin-bottom: 15px;
}

.icon {
  width: 60px;
  height: 60px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.favorite-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23ddd' viewBox='0 0 24 24'%3E%3Cpath d='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'/%3E%3C/svg%3E");
}

.history-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23ddd' viewBox='0 0 24 24'%3E%3Cpath d='M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z'/%3E%3C/svg%3E");
}

.empty-text {
  color: #999;
  font-size: 14px;
}

@media (max-width: 992px) {
  .card-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .user-info-container {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .card-grid {
    grid-template-columns: 1fr;
  }
}
</style> 